import React, { useState, useEffect } from "react";
import axios from "axios";
import Input from "../shared/Input";
import "./LeadsCreateContent.css";
import { useNavigate, useParams } from "react-router-dom";
import { FiSave, FiUsers } from "react-icons/fi";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faDownload } from "@fortawesome/free-solid-svg-icons";
import Select from "react-select";
import TabProfile from "../customersCreate/TabProfile";
import TabPassword from "../customersCreate/TabPassword";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const LeadsCreateContent = () => {
  // Rol seçimi için
  const [selectedRole, setSelectedRole] = useState(null);
  const navigate = useNavigate();
  const [selectedWarehouse, setSelectedWarehouse] = useState(null);

  // Avatar listesi ve modal kontrolü
  const [avatarList, setAvatarList] = useState([]);
  const [showAvatarModal, setShowAvatarModal] = useState(false);
  const [selectedAvatar, setSelectedAvatar] = useState("");
  const openAvatarModal = () => setShowAvatarModal(true);
  const closeAvatarModal = () => setShowAvatarModal(false);
  const [languagesOptions, setLanguagesOptions] = useState([]);

  // Roller için state
  const [rolesOptions, setRolesOptions] = useState([]);

  //  Dil Seçimi için State
  const [selectedLanguage, setSelectedLanguage] = useState(null);

  // Admin formu için state
  const [adminData, setAdminData] = useState({
    first_name: "",
    last_name: "",
    email: "",
    phone: "",
    password: "",
    role_id: "",
    adminImage: "",
    language: "",
    warehouse_id: "",
  });

  const [warehouseOptions, setWarehouseOptions] = useState([]);

  useEffect(() => {
    fetchWarehouses();
  }, []);

  const fetchWarehouses = async () => {
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/api/warehouses`,
      );

      const options = res.data.map((w) => ({
        label: w.title,
        value: w.id.toString(),
      }));

      setWarehouseOptions(options);
    } catch (err) {
      console.error("Depolar yüklenemedi", err);
    }
  };

  // Avatarları ve rolleri çek
  useEffect(() => {
    fetchAvatars();
    fetchRoles();
    fetchLanguages();
  }, []);

  const fetchLanguages = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/api/languages/list/active`,
      );
      const languages = response.data.map((lang) => ({
        label: lang.name,
        value: lang.id.toString(),
      }));

      setLanguagesOptions(languages);
    } catch (error) {
      console.error(" Diller alınamadı:", error);
    }
  };

  const fetchAvatars = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/api/avatars`,
      );

      const avatarPaths = response.data.map(
        (p) => `${process.env.REACT_APP_API_BASE_URL}${p}`,
      );

      console.log(" Avatarlar Yüklendi:", avatarPaths);
      setAvatarList(avatarPaths);
    } catch (error) {
      console.error(" Avatarlar yüklenirken hata:", error);
    }
  };

  const fetchRoles = async () => {
    try {
      const myRole = localStorage.getItem("userRole"); // örn: "superadmin"

      const token = localStorage.getItem("admin_token");
      const response = await axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/api/roles`,
        {
          headers: { Authorization: `Bearer ${token}` },
        },
      );
      console.log(" Roller API Yanıtı:", response.data);

      const activeRoles = response.data
        .filter((role) => {
          // aktif mi?
          if (role.status !== 1) return false;

          // superadmin değilsem → superadmin rolünü gösterme
          if (myRole !== "superadmin" && role.role_name === "superadmin") {
            return false;
          }

          return true;
        })
        .map((role) => ({
          label: role.role_name,
          value: role.id.toString(),
        }));

      setRolesOptions(activeRoles);
    } catch (error) {
      console.error(" Roller alınamadı:", error);
    }
  };

  const handleSubmit = async () => {
    try {
      const cleanPhone = adminData.phone.replace(/\D/g, "");

      // 1) Rol
      const selectedRoleData = rolesOptions.find(
        (r) => r.label === selectedRole?.label,
      );
      const roleId = selectedRoleData?.value;
      if (!roleId) {
        alert("Lütfen bir rol seçin!");
        return;
      }

      // 2) Dil
      const langOption = languagesOptions.find(
        (l) => l.label === selectedLanguage?.label,
      );

      const finalData = {
        ...adminData,
        phone: cleanPhone,
        role_id: roleId,
        language: langOption?.value || "",
        adminImage: selectedAvatar,
        warehouse_id: adminData.warehouse_id, // depo gönder
      };

      console.log("Gönderilecek data:", finalData);

      await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/api/leads/create`,
        finalData,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("admin_token")}`,
          },
        },
      );

      toast.success("Admin eklendi!", {
        position: "top-right",
        autoClose: 3000,
      });
      // navigate("/leads/list");
    } catch (err) {
      console.error("Admin eklenirken hata:", err);
      alert("Admin eklenirken hata oluştu! (Console'a bakınız)");
    }
  };

  // Her input için onChange fonksiyonu
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setAdminData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  // Avatar seçim işlemi
  const handleAvatarSelect = (avatar) => {
    setSelectedAvatar(avatar);
    setAdminData((prev) => ({
      ...prev,
      adminImage: avatar,
    }));
    closeAvatarModal();
  };

  return (
    <div className="col-lg-12">
      <ToastContainer />
      <div className="card border-top-0">
        <div className="tab-content">
          <TabProfile
            adminData={adminData}
            handleInputChange={handleInputChange}
            handleAvatarSelect={handleAvatarSelect}
            avatarList={avatarList}
            handleSubmit={handleSubmit}
            rolesOptions={rolesOptions}
            selectedRole={selectedRole}
            setSelectedRole={setSelectedRole}
            languagesOptions={languagesOptions}
            selectedLanguage={selectedLanguage}
            setSelectedLanguage={setSelectedLanguage}
            warehouseOptions={warehouseOptions} //  yeni
            setSelectedWarehouse={setSelectedWarehouse}
            setAdminData={setAdminData}
          />
        </div>
      </div>
    </div>
  );
};

export default LeadsCreateContent;
